export const TITLE = "Altigreen 3 Wheeler Auto Price in India 2026 | Altgreen EV Auto";

export const META_CONTENT = [
  {
    name: "description",
    content:
      "Altgreen 3 Wheeler Auto price in India ranges from ₹3.4 - ₹4.4 Lakh. Explore Altgreen commercial vehicles, range, images, features & on-road prices.",
  },
  {
    name: "keywords",
    content:
      "Altigreen electric auto, Altigreen 3 wheeler, Altigreen electric vehicles, Altigreen three wheeler, Altigreen electric auto price, Altigreen commercial vehicles, Altigreen EV auto, Altigreen electric truck, Altigreen neEV, Altigreen neEV Tez, Altigreen price in India, Altigreen dealers, Altigreen specifications, Altigreen features, Altigreen battery capacity, Altigreen range, Altigreen charging, Altigreen EMI, Altigreen financing, Altigreen test drive",
  },
  {
    name: "author",
    content: "Turno",
  },
  {
    name: "url",
    content: "https://www.turno.club/electric-commercial-vehicles/Altigreen",
  },
  {
    name: "robots",
    content: "INDEX,ARCHIVE,FOLLOW",
  },
  {
    name: "lang",
    content: "en",
  },
  {
    name: "viewport",
    content: "width=device-width, initial-scale=1",
  },
  {
    property: "og:url",
    content: "https://www.turno.club/electric-commercial-vehicles/Altigreen",
  },
  {
    property: "og:type",
    content: "website",
  },
  {
    property: "og:title",
    content: "Altigreen 3 Wheeler Auto Price in India 2026 | Altgreen EV Auto",
  },
  {
    property: "og:description",
    content:
      "Altgreen 3 Wheeler Auto price in India ranges from ₹3.4 - ₹4.4 Lakh. Explore Altgreen commercial vehicles, range, images, features & on-road prices.",
  },
  {
    property: "og:image",
    content: "/logoIcon.png",
  },
  {
    property: "fb:app_id",
    content: "5796260583761767",
  },
  {
    property: "fb:pages",
    content: "646488286564232",
  },
  {
    name: "twitter:description",
    content:
      "Altgreen 3 Wheeler Auto price in India ranges from ₹3.4 - ₹4.4 Lakh. Explore Altgreen commercial vehicles, range, images, features & on-road prices.",
  },
  {
    name: "twitter:title",
    content: "Altigreen 3 Wheeler Auto Price in India 2026 | Altgreen EV Auto",
  },
  {
    name: "twitter:site",
    content: "@Turno",
  },
  {
    name: "twitter:creator",
    content: "@Turno",
  },
  {
    name: "twitter:url",
    content: "https://www.turno.club/electric-commercial-vehicles/Altigreen",
  },
  {
    name: "twitter:app:id:googleplay",
    content: "com.customerapp.turno.turno_customer_application",
  },
  {
    name: "twitter:app:country",
    content: "IN",
  },
];

export const VEHICLE_LINK = "https://www.turno.club/electric-commercial-vehicles/Altigreen";

export const H1_HEADING = "Altigreen Electric Auto";

export const BRAND_HEADER_INFO = "Altigreen 3 Wheeler Electric Auto";

export const BRAND_DESCRIPTION = "Turno invites you to embrace India's most advanced electric commercial vehicles made by Altigreen. Explore the range of Altigreen electric auto models, including the Altigreen neEV and Altigreen neEV Tez, and experience the electrifying change that your business needs. Explore the Altigreen Electric auto range, designed to deliver the never heard before power and performance for last-mile delivery and urban logistics.";

export const PRICE_LIST_HEADER = "Altigreen 3 Wheeler Electric Auto Price List in India 2026";

export const PRICE_LIST_DESCRIPTION = "Discover the price range of Altigreen electric auto, offering sustainable and cost-effective transportation solutions for various business requirements. Altigreen electric trucks are designed to change the landscape of the commercial transportation sector with their efficiency, reliability, and fast charging abilities. Below is a table showcasing the Altigreen electric truck models along with their respective price ranges.";

export const PROMISES_HEADER = "Why Altigreen Electric Vehicles from Turno?";

export const ADVANTAGES_HEADING = "Advantages of Altigreen Electric Vehicles:";

export const ADVANTAGES_DESCRIPTION = "Turno, in partnership with Altigreen, brings you electric vehicles that redefine the norms, offering innovative solutions for modern logistics that keeps your business always a step ahead. Elevate your delivery operations with Altigreen and Turno today.";

export const HIGHLIGHTS_HEADING = "Highlights of Altigreen EV Auto:";

export const HIGHLIGHTS_DESCRIPTION = "Altigreen offers an impressive battery life, capable of covering up to 151 kilometres on a single charge. The Altigreen EV experience is characterised by simplicity of operation and a comfortable ride, offering an ideal solution for those seeking an technologically advanced vehicle that doesn't compromise on affordability.";

export const BLOG_HEADER = "Turno Blogs on Altigreen 3 Wheeler";

export const ABOUT_HEADING = "About Altigreen Electric Auto:";

export const ABOUT_DESCRIPTION = "Altigreen's neEV electric cargo vehicle is redefining last-mile delivery with its cutting-edge technology and engineering prowess backed by 28 global patents. Offering an ideal solution for sustainable transportation, neEV combines high-performance electric mobility with built for India features, all at an economical running cost. It's a significant step forward in revolutionising the landscape of electric last-mile delivery in India.";

export const MODELS_HEADER = "Altigreen Electric Commercial Models & Range:";

export const MODELS_DESCRIPTION = "All of the vehicles offered by Altigreen Goods Electric Vehicles are powered by lithium-ion batteries and come with a warranty. Altigreen Electric EV also offers a range of charging solutions, including home chargers and public chargers. Altigreen has also partnered with Exponent to provide affordable public fast charging stations. If you are looking for an affordable and efficient electric vehicle, Altigreen Electric EV has a range of vehicles that are perfect for you.";

export const DEALER_HEADER = "Altigreen EV Dealers Near Me:";

export const DEALER_DESCRIPTION = "Thanks to the expansion in the company's reach and popularity, Altigreen is rapidly making its presence felt across India. As more people are leaning towards Aligreen's high-quality mobility solutions that offer excellent value for money, Turno brings you this exceptional range of Electric Trucks at affordable prices. If you want to purchase Altigreen electric vehicles you can always head to Turno.";

export const FAQ_HEADING = "FAQs on Altigreen Electric Auto";

export const LOAN_HEADER = "Altigreen 3 Wheeler loan";

export const CTA_TEXT = "Get On Road Price";

export const CONNECT_HEADING = "Talk to Us";

export const CONNECT_SUBHEADING = "We help you find the best vehicle for your business with affordable financing. Connect with us now.";

export const CONNECT_CTA_TEXT = "Call us";

export const BREADCRUMB_ITEMS = [
  { label: "Home", href: "/" },
  { label: "Electric Commercial Vehicles", href: "/electric-commercial-vehicles" },
  { label: "Altigreen" },
];

export const BREADCRUMB_SCHEMA = {
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: [
    {
      "@type": "ListItem",
      position: 1,
      name: "Home",
      item: "https://www.turno.club/",
    },
    {
      "@type": "ListItem",
      position: 2,
      name: "Electric Commercial Vehicles",
      item: "https://www.turno.club/electric-commercial-vehicles",
    },
    {
      "@type": "ListItem",
      position: 3,
      name: "Altigreen",
      item: VEHICLE_LINK,
    },
  ],
};